import { render, staticRenderFns } from "./abstract-route-cmp.vue?vue&type=template&id=01c4000a&lang=pug&"
import script from "./abstract-route-cmp.vue?vue&type=script&lang=js&"
export * from "./abstract-route-cmp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports